import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
    bgColor: "#3F8CF2",
    accentColor: "#FFDE03",
    cardColor: "#FFFFFF",
    boardColor: "#DADFE9",
    boxShadow: "2px 2px 10px -2px rgba(0, 0, 0, 0.5)",
};
